import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Button, Flex, Img, List, ListItem, Text} from '@chakra-ui/react'
import {Link} from 'react-router-dom'
import useDamImage from '../../../../custom-hooks/use-dam-image'
import {useGetCategoriesData} from '../../../../custom-api/hooks/use-get-categories-data'
import {getGlobalLink, safeBuildUrl} from '../../../../utils/contentstack-utils'
import {remCalc} from '../../../../theme/_utils'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const SortingSliderTile = ({styles, tile, tIndex, variant}) => {
    const damImage = useDamImage(tile?.image)
    const categoryData = useGetCategoriesData()

    const {url, label, isAbsolute} = getGlobalLink(tile?.button, categoryData)
    const {buildUrl} = useMultiSite()
    const buttonProps = isAbsolute
        ? {
              as: 'a',
              href: url,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: Link,
              to: safeBuildUrl(url, buildUrl),
          }

    const spacing_24 = remCalc(24)

    return (
        <Flex
            data-testid="sorting-slider-tile-testid"
            {...styles.tile}
            className={'sorting-slider-tile'}
        >
            <Flex flexDirection={'column'} {...styles.tiletextbox}>
                {(damImage.url || tile.image?.alt) && (
                    <AspectRatio ratio={damImage.ratio} {...styles.tileimage}>
                        <Img src={damImage.url} alt={tile.image?.alt || ''} />
                    </AspectRatio>
                )}
                <Box
                    {...styles.tiletitle}
                    color={variant === 'black' ? 'text.inverse' : 'text.default'}
                    className={'tile-title'}
                >
                    {tile?.title && <Text>{tile?.title}</Text>}
                </Box>
                <Box
                    color={variant === 'black' ? 'text.inverse' : 'text.default'}
                    {...styles.tilebodycopy}
                    className={'tile-bodycopy'}
                    dangerouslySetInnerHTML={{__html: tile?.body_copy || ''}}
                />
                {tile.features?.length > 0 && (
                    <Box color={variant === 'black' ? 'text.inverse' : 'text.default'}>
                        <List {...styles.features}>
                            {tile?.features
                                .filter((feature) => !!feature?.feature?.trim())
                                .map((feature, fIndex) => (
                                    <ListItem
                                        key={`tile-${tIndex}-feature-${fIndex}`}
                                        borderTop={fIndex === 0 ? 'none' : '1px solid #efefef'}
                                        {...styles.feature}
                                        _first={{pt: spacing_24}}
                                        _last={{pb: spacing_24}}
                                        className={'tile-feature'}
                                    >
                                        {feature?.feature}
                                    </ListItem>
                                ))}
                        </List>
                    </Box>
                )}
            </Flex>
            {label && url && (
                <Button
                    {...buttonProps}
                    {...styles.cta}
                    variant={variant === 'black' ? 'inverse-primary' : 'primary'}
                >
                    {label}
                </Button>
            )}
        </Flex>
    )
}

SortingSliderTile.propTypes = {
    styles: PropTypes.shape(),
    tile: PropTypes.shape({
        title: PropTypes.string,
        body_copy: PropTypes.string,
        image: PropTypes.shape(),
        features: PropTypes.arrayOf(PropTypes.shape({feature: PropTypes.string})),
        button: PropTypes.shape(),
    }),
    tIndex: PropTypes.number,
    variant: PropTypes.string,
}
